/**
 * PHARMAKON — Fournisseur ERP · « Réclamations reçues » menu badge (refonte WP-36; A-20, ux/03 §5.8,
 * ux/01 §6.10: badge `reclamations` = unread + awaiting action).
 *
 * One count, read from `GET /fournisseur-portail/reclamations/badge` (the server counts each
 * réclamation once). Nothing polls here: the portal shell reads it when it mounts and whenever the
 * notification feed's unread count moves (the existing feed poll — a RECLAMATION_RECUE / _MESSAGE /
 * _CLOTUREE notification arrives with every pharmacy event); the réclamation pages re-read it after
 * opening a document (which marks it read) and after each of the supplier's actions (targeted
 * invalidation). A read asked while one is in flight runs once the first returns.
 */
import { create } from "zustand";
import reclamationsRecuesService from "../../api/fournisseur/reclamation.service.js";
import { badgeReclamations } from "../../lib/reclamation-portail.js";

export const useFournisseurReclamationStore = create((set, get) => ({
  badge: 0,
  enCours: false,
  relire: false,

  fetchBadge: async () => {
    if (get().enCours) {
      set({ relire: true });
      return;
    }
    set({ enCours: true, relire: false });
    try {
      set({ badge: badgeReclamations(await reclamationsRecuesService.badge()) });
    } catch {
      /* a failed read never breaks the menu: the last count stays */
    } finally {
      set({ enCours: false });
      if (get().relire) get().fetchBadge();
    }
  },

  reset: () => set({ badge: 0, enCours: false, relire: false }),
}));

export default useFournisseurReclamationStore;
